export const HOME = '/';
export const LOGIN = '/login';
export const RESET = '/reset';
export const NEW_PASSWORD = '/new_password/:token/:email';
export const PRIVACY = '/privacy';
export const SSO_ERROR = '/sso/error';
export const NOT_FOUND = '/NOT_FOUND';
export const REPORT = '/report';
export const HELP = '/help';
export const TEST = '/test';
export const TEST_START = '/start';
export const TESTS = '/tests';
export const CAMPAIGNSELECTOR = '/select-campaign';
export const QUESTIONNAIRE360 = '/skillup-360';
export const EVALUATION360 = '/skillup-360/questionnaire';
export const SSO_LOGIN_SHORTCUT = '/sso/:slug';
export const SSO_LOGOUT = '/sso/logout';

export function getParametricRoute(route, params = {}) {
  if (!route || typeof route !== 'string') {
    return '';
  }

  let res = route;
  Object.keys(params).forEach(key => {
    const newVal = params[key];
    res = res.replace(`:${key}`, newVal !== null && newVal !== undefined ? newVal : '');
  });

  return res;
}
